import { InputHTMLAttributes } from 'react'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import { SearchIcon } from 'components/Icons/SearchIcon'
import { Input, SearchContainer } from 'components/InputSearch/styles'
import { IoCloseSharp } from 'react-icons/io5'

interface InputSearch extends InputHTMLAttributes<HTMLInputElement> {
    register?: UseFormRegister<FieldValues>
    name: string
    searchValue: string
    handleCleanInputSearch: () => void
}

const InputSearch: React.FC<InputSearch> = ({
    register,
    name,
    searchValue,
    handleCleanInputSearch,
    ...rest
}) => {
    return (
        <SearchContainer>
            <SearchIcon className="absolute ml-2" />
            <Input {...(register && register(name || 'input'))} {...rest} />

            {searchValue !== undefined && searchValue !== '' && (
                <IoCloseSharp
                    data-testid="clean-icon"
                    onClick={handleCleanInputSearch}
                    className="text-blueTheme absolute right-0 mr-[13.5px] w-5 h-5"
                />
            )}
        </SearchContainer>
    )
}

export { InputSearch }
